import createApp from 'createApp'
import { mapActions, mapState } from 'vuex'
import { parse as parseUrl } from 'url'
import { parse as parseQuery } from 'qs'
import documentOffset from 'document-offset'
const asideFilter = () => import('Components/CategoryDirectory/Aside/asideFilter.vue')
const asideMode = () => import('Components/CategoryDirectory/Aside/asideMode.vue')
const asideServiceType = () => import('Components/CategoryDirectory/Aside/asideServiceType.vue')
const asideSort = () => import('Components/CategoryDirectory/Aside/asideSort.vue')
const asideUsefulInfo = () => import('Components/CategoryDirectory/Aside/asideUsefulInfo.vue')
const categoryJumbotron = () => import('Components/CategoryDirectory/categoryJumbotron.vue')
const categoryQuotationBar = () => import('Components/CategoryDirectory/categoryQuotationBar.vue')
const categoryReview = () => import('Components/CategoryDirectory/categoryReview.vue')
const viewList = () => import('Components/CategoryDirectory/View/ViewList.vue')
const categoryInformation = () => import('Components/CategoryDirectory/categoryInformation.vue')
const categoryQuestionBox = () => import('Components/CategoryDirectory/categoryQuestionBox.vue')
const categoryQuestion = () => import('Components/CategoryDirectory/categoryQuestion.vue')
const categoryBreadcrumb = () => import('Components/CategoryDirectory/categoryBreadcrumb.vue')
const categoryToolbar = () => import('Components/CategoryDirectory/categoryToolbar.vue')
const categorySupplier = () => import('Components/CategoryDirectory/categorySupplier.vue')
import emptyFavorite from "Components/CategoryDirectory/Empty/emptyFavorite.vue"
import emptyList from "Components/CategoryDirectory/Empty/emptyList.vue"
import categoryBox from "Components/CategoryDirectory/categoryBox.vue"
import { StoreState } from 'Types'
const asideCategoryDirectory = () => import('Components/CategoryDirectory/Aside/asideCategoryDirectory.vue')

createApp({
  components: {
    asideFilter,
    asideMode,
    asideServiceType,
    asideSort,
    asideUsefulInfo,
    categoryInformation,
    categoryJumbotron,
    categoryQuestion,
    categoryQuestionBox,
    categoryQuotationBar,
    categoryReview,
    viewList,
    categoryToolbar,
    categorySupplier,
    emptyFavorite,
    emptyList,
    categoryBox,
    asideCategoryDirectory,
    categoryBreadcrumb
  },

  computed: {
    ...mapState({
      selected: (state: StoreState) => state.categoryDirectory.selected,
      isAuthenticated: (state: StoreState) => state.account.authenticated,
      isRequesting: (state: StoreState) => state.categoryDirectory.requesting,
      companyList: (state: StoreState) => state.categoryDirectory.companyList,
    }),

    isEmpty() {
      return this.companyList.length === 0
        && !this.isRequesting.companies
        && this.selected.mode.type !== 'map'
    },

    emptyState() {
      return this.selected.favorite
        ? () => import('Components/CategoryDirectory/Empty/emptyFavorite.vue')
        : () => import('Components/CategoryDirectory/Empty/emptyList.vue')
    },

    viewMode() {
      const getComponent = (type) => ({
        list: viewList,
        grid: () => import('Components/CategoryDirectory/View/ViewGrid.vue'),
        map: () => import('Components/CategoryDirectory/View/ViewMap.vue'),
      }[type])

      return getComponent(this.selected.mode.type) || viewList
    }
  },

  created() {
    if (this.isAuthenticated && !this.selected.favorite) {
      const authenticated = this.isAuthenticated

      this.updateCategorySelected({ authenticated })
    }

    this.updateQueries()
  },

  mounted() {
    this.updatePaginationPosition()
  },

  methods: {
    ...mapActions({
      updateCategorySelected: 'categoryDirectory/updateCategorySelected',
      getPreviousList: 'categoryDirectory/getPreviousList',
    }),

    loadPreviousCompanies(scrollListener = null) {
      this.getPreviousList()

      if (scrollListener) { window.removeEventListener('scroll', scrollListener) }
    },

    async updatePaginationPosition() {
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual'
      }

      document.body.style.setProperty('overflow-anchor', 'none')
      document.documentElement.style.setProperty('scroll-behavior', 'auto')

      const { query } = parseUrl(location.href)
      const { page } = parseQuery(query)

      if (page > 1) {
        const { companyList } = this.$refs
        const elementOffset = documentOffset(companyList.$el)

        window.scroll(0, elementOffset.top)

        document.documentElement.style.removeProperty('overflow-anchor')
        document.documentElement.style.removeProperty('scroll-behavior')

        await this.$nextTick()

        const currentScrollPos = window.scrollY

        const scrollListener = () => {
          if (window.scrollY < currentScrollPos) { this.loadPreviousCompanies(scrollListener) }
        }

        window.addEventListener('scroll', scrollListener, { passive: true })
      }
    },

    updateQueries() {
      const { query } = parseUrl(location.href)
      const { sort: sortQs = false, companies: companyQs = false } = parseQuery(query)

      let sort = 0
      let companies = []

      if (sortQs) {
        sort = parseInt(sortQs)
      }

      if (companyQs) {
        const companiesList = companyQs.split(',') || []

        companies = companiesList.map(company => {
          const splitedInfo = company.split('*')
          return {
            id: parseInt(splitedInfo[0]),
            name: splitedInfo[1]
          }
        })
      }

      this.updateCategorySelected({ sort, companies })
    },

    updateFilter() {
      const { pathname } = parseUrl(location.href)
      const favorite = pathname.indexOf('/favoritos/') !== -1

      this.updateCategorySelected({ favorite })
    }
  },
})
